export const AUDIT_FORMS_QUERY_KEY = 'audit-forms';
